import React from 'react';
import './navbtn.css'

const Navbtn = (props) => {
    return ( 
        <button className="navbtn">
            <img src={props.navicon} alt="" className='navicon'/>
            <li className={props.selected}>{props.page}</li>
        </button>
     );
}
 
export default Navbtn;